<template>
    <div>
        <component ref="component" :is="template" :steps="chatSteps" :userData="userData" @nextStep="nextStep"></component>
    </div>
</template>
<script>
 import TemplateInputs from './inputs.vue'
 import TemplatePortfolio from './portfolio.vue'
 import { v4 as uuid } from 'uuid';
 import telemetry from '@frontend/api/Telemetry';
 import {markdownTable} from 'markdown-table'


 export default {
    name: 'IntelligentAdvisor',
    components: {
        TemplateInputs,
        TemplatePortfolio
    },
    data() {
        return {
            step: 'inputs',
            prospectName: '',
            age: '',
            saving: '',
            retirementAge: '',
            userData: {},
            chatSteps: [ { icon: '💰', label: 'Fees', message:"Tell me about fees." },
                { icon: '📊', label: 'Equity Sector Diversification', message: 'Tell me about my equity sector diversification.' },
                { icon: '📈', label: 'Asset Allocation / Risk', message: 'Tell me about my asset allocation and whether I have the right risk allocation.' },
                { label: 'Improve', icon: '🔧' }] }
    },
    created() {
        let telemetryToken = window.localStorage.getItem('telemetryToken');
        if (!telemetryToken) {
            telemetryToken = uuid();
        }
        window.localStorage.setItem('telemetryToken', telemetryToken);
        this.userData = { ...this.userData, telemetryToken: uuid(), portfolioCheckup: true };

    },
    methods: {
        formatHoldings(holdings) {
            console.log('Formatting Holdings')
            console.log(holdings)
            holdings.forEach(item => {
                item.Dollars = item.Dollars.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
                item.Fees = item.Fees.toLocaleString('en-US', {maximumFractionDigits: 2}) + '%'
            })            
            return holdings;
        },
        calculateWeightedFees(holdings) {
            let totalDollars = holdings.reduce((total, obj) => total + parseFloat(obj.Dollars), 0);
            return holdings.reduce((total, obj) => total + obj.Fees * obj.Dollars, 0) /  totalDollars;
        },
        setfeeComparison(averageFee) {
            // This is {feeComparison} the average index fund
            let feeComparison = "lower than";
            if (averageFee > .8) {
                feeComparison = "much higher than"
            } else if (averageFee > .25) {
                feeComparison = "high compared to"
            } else if (averageFee > .08) {
                feeComparison = "comparable to"
            };
            console.log('fee comparison before return')
            console.log(feeComparison)
            
            return feeComparison;
        },
        setcostSave(averageFee) {
            let costSave = "Cost"
            if (averageFee < .12) {
                costSave = "Save"
            }
            return costSave;
        },
        calculateChatSteps(holdings, bySector, byAssetType) {



            this.userData.totalDollars = holdings.reduce((total, obj) => total + parseFloat(obj.Dollars), 0);
            let averageFee = holdings.reduce((total,obj)=> total + obj.Fees * obj.Dollars, 0);
            if (this.userData.totalDollars > 0) {
                averageFee = averageFee / this.userData.totalDollars;
            } else {
                averageFee = 0;
            }
            this.userData.averageFee = averageFee
            this.userData.feeComparison = this.setfeeComparison(averageFee)
            let table = [['Year', 'Your Portfolio Fees', 'Average Index Fund Fees']]
            let yearFee = this.userData.totalDollars * averageFee/100
            let totalFees = this.userData.totalDollars * averageFee/100
            let benchYearFee = this.userData.totalDollars * .12/100
            let benchTotalFees = this.userData.totalDollars * .12/100

            for(let i = 0; i < 20; i++) {

                table.push([i + "",totalFees,benchTotalFees])
                yearFee = yearFee * 1.08
                totalFees += yearFee
                benchYearFee = benchYearFee * 1.08
                benchTotalFees += benchYearFee
            }
            table.push([20 + "",totalFees,benchTotalFees])

            this.chatSteps[0].message = `Your average fees are <b>${this.userData.averageFee.toLocaleString('en-US',{maximumFractionDigits:2})}%</b>. This is <b><u>${this.userData.feeComparison}</u></b> the average index fund, which has fees of <b>0.12%</b>. With your current savings amount of ${this.userData.totalDollars.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })},`
            if (this.userData.averageFee > 0) {
                this.chatSteps[0].message += ` your fees could cost you ${totalFees.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })} over the next 20 years (assuming 8% investment returns).`
            } else {
                this.chatSteps[0].message += ` this could save you ${benchTotalFees.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })} over the next 20 years (compared to the average index fund fees, assuming 8% investment returns).`
            }
            this.chatSteps[0].message += "\n" 

            // CREATE CHARTS BELOW 
            // Line chart for fees
            this.chatSteps[0].message += "```linechart\n" + markdownTable(table) + "\n```\n"
            this.chatSteps[0].message += "\n"


            // Bar chart for sector diversification
            this.userData.benchmark = {'Communication Services': 0.089, 'Consumer Discretionary': 0.105, 'Consumer Staples': 0.070, 'Energy': 0.044, 'Financials': 0.108, 'Health Care': 0.151, 'Industrials': 0.080, 'Information Technology': 0.277, 'Materials': 0.026, 'Real Estate': 0.029, 'Utilities': 0.031}
            this.chatSteps[1].message = 'Your equity sector diversification is as follows: \n'
            let sectors = Object.keys(bySector)
            table = [['Sector','Your Portfolio','S&P 500']]
            sectors.forEach((sector) => {
                table.push([sector, bySector[sector], this.userData.benchmark[sector]])
            })

            this.chatSteps[1].message += "```barchart\n" + markdownTable(table) + "\n```\n"
            this.chatSteps[1].message += "\n"

            this.chatSteps[2].message = 'Your asset allocation is as follows: \n'
            let assetTypes = Object.keys(byAssetType)
            table = [['Asset Type','Your Portfolio','Peer Comparison']]
            // TODO: Add international breakdown. International if: identifier contains a "." or isin starts with non-US or matchmaker figi security type is ADR

            let allocation_vs_years_to_retirement = {
                "-8": {'Stocks': 0.29,'Bonds': 0.66,'Other': 0.05},
                "-3": {'Stocks': 0.41, 'Bonds': 0.56, 'Other': 0.03},
                "2": {'Stocks': 0.54, 'Bonds': 0.43, 'Other': 0.03},
                "7": {'Stocks': 0.62, 'Bonds': 0.35, 'Other': 0.03},
                "12": {'Stocks': 0.69, 'Bonds': 0.28, 'Other': 0.03},
                "17": {'Stocks': 0.77, 'Bonds': 0.20, 'Other': 0.03},
                "22": {'Stocks': 0.84, 'Bonds': 0.13, 'Other': 0.03},
                "27": {'Stocks': 0.88, 'Bonds': 0.09, 'Other': 0.03},
            }
            let allocation_years = [-8,-3,2,7,12,17,22,27]
            let years_to_retirement = this.userData.retirementAge - this.userData.age
            let closestItem = allocation_years[0];

            for (let i = 1; i < allocation_years.length; i++) {
                let currentDiff = Math.abs(allocation_years[i] - years_to_retirement);
                let closestDiff = Math.abs(closestItem - years_to_retirement);
                if (currentDiff < closestDiff) {
                    closestItem = allocation_years[i];
                }
            }
            let allocation = allocation_vs_years_to_retirement[closestItem.toString()]


            console.log('allocation', allocation)
            assetTypes.forEach((assetType) => {
                console.log('ALLOCATION ASSSET TYPE', allocation[assetType])
                table.push([assetType, byAssetType[assetType], allocation[assetType]])
            })
            this.chatSteps[2].message += "```markdown\n" + markdownTable(table) + "\n```\n"


        },
        nextStep(event) {
            if (event.module === 'input') {
                this.userData.age = event.age
                this.userData.prospectName = event.prospectName
                this.userData.retirementAge = event.retirementAge
                this.step = 'portfolio'
            } else if (event.module === 'portfolio') {
                let tableKeys = new Set(event.holdings.map((obj) => Object.keys(obj)).reduce((a, b) => Array.from(new Set(a.concat(b))), []));
                tableKeys.delete('Breakdown')
                tableKeys.delete('AssetType')
                tableKeys = Array.from(tableKeys)
                let bySector = {'Communication Services': 0, 'Consumer Discretionary': 0, 'Consumer Staples': 0, 'Energy': 0, 'Financials': 0, 'Health Care': 0, 'Industrials': 0, 'Information Technology': 0, 'Materials': 0, 'Real Estate': 0, 'Utilities': 0}
                let byAssetType = {}
                let totalAssetDollars = 0 
                let totalSectorDollars = 0

                event.holdings.forEach((holding) => {
                    if (holding.Breakdown) {
                        Object.keys(holding.Breakdown).map((sector) => {
                            if (bySector[sector]) {
                                bySector[sector] += holding.Breakdown[sector] * holding.Dollars
                            } else {
                                bySector[sector] = holding.Breakdown[sector] * holding.Dollars
                            }
                        })
                        totalSectorDollars += holding.Dollars
                    } 
                    if (holding.AssetType) {
                        Object.keys(holding.AssetType).forEach((assetType) => {
                            if (byAssetType[assetType]) {
                                byAssetType[assetType] += holding.Dollars *  holding.AssetType[assetType]
                            } else {
                                byAssetType[assetType] = holding.Dollars * holding.AssetType[assetType]
                            }
                        })
                        totalAssetDollars += holding.Dollars
                    }
                })
                if (totalAssetDollars > 0) {
                    Object.keys(byAssetType).forEach((assetType) => {

                        byAssetType[assetType] = byAssetType[assetType] / totalAssetDollars
                    })
                }
                if (bySector[null]) {
                    bySector['Other'] = bySector[null]
                    delete bySector[null]
                }
                if (bySector['']) {
                    if(!bySector['Other']) {
                        bySector['Other'] = 0
                    }
                    bySector['Other'] += bySector['']
                    delete bySector['']
                }
                if (bySector[parseFloat('nan')]) {
                    if(!bySector['Other']) {
                        bySector['Other'] = 0
                    }
                    bySector['Other'] += bySector[parseFloat('nan')]
                    delete bySector[parseFloat('nan')]
                }
                if (bySector['nan']) {
                    if(!bySector['Other']) {
                        bySector['Other'] = 0
                    }
                    bySector['Other'] += bySector['nan']
                    delete bySector['nan']
                }
                if(totalSectorDollars > 0) {
                    Object.keys(bySector).forEach((sector) => {
                        bySector[sector] = bySector[sector] / totalSectorDollars
                    })
                }
                this.calculateChatSteps(event.holdings, bySector, byAssetType)
                this.step = 'chatbot'
            }
        }
    },
    computed: {
        template() {
            if (this.step === 'inputs') {
                return TemplateInputs
            } else if (this.step === 'portfolio') {
                return TemplatePortfolio
            } else {
                return ChatBot
            }
        }
    }
 }
</script>
